//jquery.cookie.js
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(e){var n=/\+/g;function o(e){return r.raw?e:encodeURIComponent(e)}function i(o,i){var t=r.raw?o:function(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(n," ")),r.json?JSON.parse(e):e}catch(e){}}(o);return e.isFunction(i)?i(t):t}var r=e.cookie=function(n,t,c){if(arguments.length>1&&!e.isFunction(t)){if("number"==typeof(c=e.extend({},r.defaults,c)).expires){var u=c.expires,s=c.expires=new Date;s.setMilliseconds(s.getMilliseconds()+864e5*u)}return document.cookie=[o(n),"=",(a=t,o(r.json?JSON.stringify(a):String(a))),c.expires?"; expires="+c.expires.toUTCString():"",c.path?"; path="+c.path:"",c.domain?"; domain="+c.domain:"",c.secure?"; secure":""].join("")}for(var a,d,p=n?void 0:{},f=document.cookie?document.cookie.split("; "):[],l=0,m=f.length;l<m;l++){var x=f[l].split("="),g=(d=x.shift(),r.raw?d:decodeURIComponent(d)),v=x.join("=");if(n===g){p=i(v,t);break}n||void 0===(v=i(v))||(p[g]=v)}return p};r.defaults={},e.removeCookie=function(n,o){return e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n)}});

$(document).ready(function() {
  //  console.log( "ready!" );



// country selection
  // If we're forcing a country on page load, set the cookie immediately
  if (getParameterByName('country')) {
    $.cookie('country', getParameterByName('country'), { expires: 365, path: '/' });
  };
  

   

  // 1 ms timeout to ensure cookie has time to be set above, if necessary
  setTimeout(function() {
    // Do you have a cookie?
    if ($.cookie('country')) {
      // Yes, let's just double check you're on the right site...
      checkDomain($.cookie('country'));
      
    } else {
      // No, let's figure out which country you're in and set it
      
        $.ajax({
		url: "https://geoip-db.com/jsonp",
		jsonpCallback: "callback",
		dataType: "jsonp",
		success: function( location ) {
			console.log(location.country_code);
			checkDomain(location.country_code);
		}
        });
      
      
      
    }

  }, 1);

  // Changing country via the menu
  $('.country-select .country').click(function() {
    countryRedirect($(this).attr('data-country'));
  });

  function isKnownDomain(current_domain) {
    var knownDomains = [
      'hexbrand.co.uk',
      'www.hexbrand.com'
    ];

    return knownDomains.indexOf(current_domain) > -1;
  }


function countryRedirect(country) {

  var domain = getDomain(country);
  var current_domain = document.location.hostname;

  if (domain != current_domain) {
    // We're on the wrong website for your country, redirect out
    var path = document.location.pathname;
    document.location.href = 'https://' + domain + path + '?country=' + country;
  } else {
    // This is the right site, set a cookie
    $.cookie('country', country, { expires: 365, path: '/' });
    
    console.log(country);

    // If this is the US or EU site and we're on a product page, reload the page since changing the country could result in different distributors/amazon appearing
    if ((domain == 'www.hexbrand.com') && document.location.pathname.indexOf('/products') > -1) {
      document.location.href = document.location.href.split('?')[0];
    } else if (domain == 'www.hexbrand.com' && document.location.pathname.indexOf('/pages/contact') > -1) {
      // Same deal, but for the contact page since we'll need to show a new phone number
      document.location.reload();
    }
  }
}

function checkDomain(country) {
  var domain = getDomain(country);
  var current_domain = document.location.hostname;
  
  console.log(domain);
  console.log(current_domain );

  if (isKnownDomain(current_domain) && domain != current_domain) {
    console.log('redirect');
    countryRedirect(country);
  }
}

function getDomain(country) {
  switch (country) {
    case 'AD':
    case 'AL':
    case 'AT':
    case 'BA':
    case 'BE':
    case 'BG':
    case 'BY':
    case 'CH':
    case 'CZ':
    case 'DE':
    case 'DK':
    case 'EE':
    case 'ES':
    case 'FI':
    case 'FO': 
    case 'FR':   
    case 'GB':
    case 'GG':
    case 'GI':
    case 'GR':
    case 'HR':
    case 'HU':
    case 'IE':
    case 'IM':
    case 'IS':
    case 'IT':
    case 'JE':
    case 'LI':
    case 'LT':
    case 'LU':
    case 'LV':
    case 'MC':
    case 'MD':
    case 'ME':
    case 'MT':
    case 'NL':
    case 'NO':
    case 'PL':
    case 'PT':
    case 'RO':
    case 'RS':
    case 'SE':
    case 'SI':
    case 'SK':
    case 'SM':
    case 'UA':   
    case 'UK':
      var domain = 'hexbrand.co.uk';
      break;
    default:
      var domain = 'www.hexbrand.com';
  }

  return domain;
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

});

